import { CATALOG_FILTER_EXISTS } from '@backstage/catalog-client';
import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import { TECHDOCS_REF_ANNOTATION } from './constants';

/** Queries the catalog directly so the curated docs are unaffected by the sidebar filters. */
export const useCuratedTechDocs = (names: string[]): Entity[] => {
  const catalogApi = useApi(catalogApiRef);

  const { value } = useAsync(async () => {
    const { items } = await catalogApi.getEntities({
      filter: {
        'metadata.name': names,
        [`metadata.annotations.${TECHDOCS_REF_ANNOTATION}`]:
          CATALOG_FILTER_EXISTS,
      },
    });

    return items;
  }, [catalogApi, names]);

  return value ?? [];
};
